import * as React from "react";

// Components
import PageTransition from "@/components/Atoms/PageTransition";
import Seo from "@/components/Organisms/seo";
import SeeUBBAnimation from "@/components/Molecules/SeeUBBAnimation";
import Opening from "@/components/Organisms/Opening";
import Description from "@/components/Pages/Start/Description";

// Data
import MetaData from "@/module/data/meta/start";
import { AnimatePresence, motion } from "framer-motion";

const Index: React.FC = () => {
  //initialize
  const [pageShowFlag, setPageShowFlag] = React.useState(true);
  const [openingEndFlag, setOpeningSenFlag] = React.useState(false);

  return (
    <>
      <PageTransition isShow={pageShowFlag}>
        <Seo
          title={MetaData.title}
          url={MetaData.url}
          description={MetaData.description}
        />
        <AnimatePresence exitBeforeEnter={true}>
          {openingEndFlag === false && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              key={"opening"}
            >
              <Opening
                onAnimationEnd={() => {
                  setOpeningSenFlag(true);
                }}
              >
                <SeeUBBAnimation />
              </Opening>
            </motion.div>
          )}
          {openingEndFlag === true && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              key={"description"}
            >
              <Description
                onPageMove={() => {
                  setPageShowFlag(false);
                }}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </PageTransition>
    </>
  );
};

export default Index;
